<template>
  <div class="h-full rounded-lg flex flex-col gap-2">
    <div id="custom-popup" class="popup">
      <div class="popup-content">
        <p>Are you sure you want to continue?</p>
        <button id="confirm-button">Yes</button>
        <button id="cancel-button">No</button>
      </div>
    </div>
    <!-- <div class="max-w-[100px]">
        </div> -->
    <div class="flex flex-col gap-2 overflow-y-auto scrollbar-thin scrollbar-tema">
      <AppFilterForm :tabela="tabela" :visibility="show_form_filter" @close="closeFilterForm" />
      <div class="flex flex-col md:flex-row gap-2">
        <AppViaturaForm :show="show_form" :disable_visibility="true" :update_visibility="true" :form_title="form_title"
          :form_data="viatura_formData" :create_btn="create_viatura_" :set_data="viatura_setData" @close="closeForm"
          @show_table="show_form_table" @create="create_viatura" @update="update_viatura" @disable="disable_viatura"
          @maintenance="add_manutencao" @add_oficina="add_oficina" />

        <AppCalendar :show="show_calendar" :dates="viatura_manutencao" title="Calendário de Manuntenção"
          @close="close_calendar" @save="save_calendar" />

        <div id="table_container" class="h-full flex flex-col gap-2">
          <div>
            <AppTablePagination v-if="show_generic_table" :visibility="true" :show="show_generic_table"
              :table_data="generic_table_data" :groupby="{show:show_groupby, field:'equipamento'}" :table_title="generic_table_title" @row-clicked="select_generic_row"
              @close="close_generic_table" :urlString="urlString" :refresh="refresh" @refreshes="refresh=false" :confirmationProps="popUp"
              :queryCampo="{ campo: 'armazem_filtro', valor: 'armazem_viatura' }" />

          </div>

          <div></div>
        </div>
      </div>
      <div class="w-full">
         <GenericDataTable
        v-if="validPermission('V0002')"
        ref="dataTableRef"
        @row-click="select_viatura"
        :api-url="`${baseURl}/api/v1/viatura/pagination/`"
        :useServerSide="true"
        :columns="viaturaColumns"
        :preserve-api-order="true"
        :initial-params="currentFilters"
        :show_export="true"
        :show_close_btn="false"
        table_title="Viaturas"
      >
        <template #left-actions>
          <button
            class="action-btn filter-btn"
            @click="showFilter = !showFilter"
            title="Filtros"
          >
            <i class="fa-solid fa-filter"></i>
          </button>
          <button
            class="action-btn filter-btn"
            @click="triggerAction({ action: 'create_viatura' })"
            title="Adicionar"
          >
            <i class="fa-solid fa-circle-plus fa-xl"></i>
          </button>
        </template>
      </GenericDataTable>
      <!-- <ViaturaFilter v-if="showFilter" :data="filter_data" @save="set_filter" @close="showFilter = false" /> -->


      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import AppTable from "@/components/tables/table.vue";
import AppInfoCard from "@/components/infoCard.vue";
import AppProfileSearch from "@/components/profileSearch.vue";
import AppSearch from "@/components/search.vue";
import AppNotification from "@/components/notification.vue";
import AppButton from "@/components/updated/button.vue";
import AppCalendar from "@/components/calendario/calendario.vue";
import AppForm from "@/components/form.vue";
import AppViaturaForm from "@/components/forms/viatura/viaturaForm.vue";
import AppFilter from "@/components/filter/filter.vue";
import AppFilterForm from "@/components/filter/filterForm.vue";
import "@fortawesome/fontawesome-free/css/all.css";
import { toast } from "vue3-toastify";
import permissionMixin from "@/permissionMixin.js";
import ViaturaFilter from "@/components/popUps/viaturaFilter.vue";
import GenericDataTable from "@/components/dataTable/GenericDataTable2.vue";

export default {
  mixins: [permissionMixin],
  name: "appviaturas",
  components: {
    ViaturaFilter,
    AppTable,
    AppInfoCard,
    AppForm,
    AppFilter,
    AppProfileSearch,
    AppSearch,
    AppNotification,
    AppViaturaForm,
    AppButton,
    AppCalendar,
    AppFilterForm,
    GenericDataTable,
  },
  
  data() {
    return {
      filter_data: null,
      showFilter: false,
      urlString: "viatura/tablefilter",

      baseURl: process.env.VUE_APP_URL_BASE,
      refresh: false,
      //viaturas: [],
      viatura: {},
      viatura_tipos: [],

      viatura_manutencao: [],

      armazens: [],
      utilizadores: [],
      GPS: [],
      transferencias: [],
      entregas: [],
      mapas: [],
      recolhas: [],
      devolucoes: [],

      generic_table_data: [],

      generic_table_title: "Generic Table",
      current_table: "none",

      show_form: false,
      show_table: true,
      show_action_card: true,
      show_generic_table: false,
      show_calendar: false,
      show_groupby: false,

      form_title: "No Title",

      create_viatura_: false,

      filter_data: {},


      viatura_formData: {},
      viatura_setData: {},

      //   FilterForm data
      filtroData: {},
      show_form_filter: false,
      selectedFiltro: "",
      filtroOptions: [],
      tabela: "viatura",
      table_title: "Viaturas",

      popUp: {
        show: false,
        message: "",
      },
      viaturaColumns:[
        {
          key: "marca",
          label: "Marca",
          type: "text",
          maxWidth: 100,
        },
        {
          key: "modelo",
          label: "Modelo",
          type: "text",
          maxWidth: 100,
        },
        {
          key: "matricula",
          label: "Matrícula",
          type: "text",
          maxWidth: 100,
        },
        {
          key: "cor",
          label: "Cor",
          type: "text",
          maxWidth: 100,
        },
        {
          key: "tipo.nome",
          label: "Tipo",
          type: "text",
          maxWidth: 150,
        },
        {
          key: "armazem.nome",
          label: "Armazém",
          type: "text",
          maxWidth: 150,
        },
        {
          key: "utilizador",
          label: "Utilizador",
          type: "text",
          maxWidth: 150,
        },
        {
          key: "gps",
          label: "GPS",
          type: "text",
          maxWidth: 100,
        },
        {
          key: "status",
          label: "Status",
          type: "badge",
          maxWidth: 90,
        }
      ]
    };
  },
  created() {
    this.setViaturaForm(null);
    console.log("utilizador:", this.utilizador);
  },
  methods: {
    set_filter(data) {
  this.urlString = "viatura/tablefilter";
  this.filter_data = JSON.parse(JSON.stringify(data));
  this.refresh = true;
  this.showFilter = false;
}

,
    async get_viaturas() {
      this.refresh = true;
    },


    async create_viatura(data) {
      console.log("view create_form_data:", data);

      let create_data = this.setData(data);
      console.log("viatura to create", create_data);

      const res = await this.create(
        create_data,
        `${this.baseURl}/api/v1/viatura/registrar/`
      );
      if (res) {
        data.id = res.id;
        await this.manage_manutencao(res);
        this.closeForm();
        toast.success("Viatura criada com sucesso", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });

        console.log("response:", res);
        await this.get_viaturas();
        await this.upload_img(data);
        this.show_table = true;
      } else {
        toast.error("Erro ao criar Viatura", {
          autoClose: 1000,
        });
      }
    },

    async select_viatura(data) {
      this.close_generic_table();
      this.close_calendar();
      this.clear_manutencao();

      this.create_viatura_ = false;
      this.form_title = "Informação Da Viatura";
      const viatura = await this.select(
        `${this.baseURl}/api/v1/viatura/${data.id}/`
      );
      console.log("selected viatura:", viatura);
      if (viatura) {
        this.viatura = JSON.parse(JSON.stringify(viatura));
        let viatura_manutencao = await this.select(
          `${this.baseURl}/api/v1/manutencao/s/viatura_id/${data.id}/?exact=true`
        );

        this.viatura_manutencao = viatura_manutencao.map((value) => ({
          id: value.id,
          start: new Date(value.inicio.replace(/-/g, "/")),
          end: new Date(value.fim.replace(/-/g, "/")),
          descricao: value.descricao,
          aceite: value.aceite,
          utilizador_id: value.utilizador_id,
          status: value.status,
        }));
        console.log("manutencao:", this.viatura_manutencao);

        this.setViaturaForm(viatura);
        await this.get_imagem(viatura.id);
        this.show_form = true;
      }
    },

    async update_viatura(data) {
      console.log("viatura to update:", data);

      let update_data = this.setData(data);
      console.log("viatura ready to update", update_data);

      const res = await this.update(
        `${this.baseURl}/api/v1/viatura/editar/${data.id}/`,
        update_data
      );
      if (res) {
        console.log("viatura updated", res);
        await this.manage_manutencao(res);
        this.closeForm();
        toast.success("Viatura atualizada com sucesso", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });

        console.log("response:", res);
        await this.get_viaturas();
        await this.upload_img(data);
        this.show_table = true;
      } else {
        toast.error("Erro ao atualizar Viatura", {
          autoClose: 1000,
        });
      }
    },
    async remove_viatura(data) {
      console.log("viatura to remove:", data);
      const res = await this.remove(
        `${this.baseURl}/api/v1/viatura/eliminar/${data.id}/`
      );
      if (res) {
        this.close_generic_table();
        this.closeForm();

        await this.get_viaturas();
      }
    },

    closeForm() {
      this.show_form = false;
      this.close_generic_table();
      this.close_calendar();
    },
    closeFilterForm() {
      this.show_form_filter = false;
    },

    close_table() {
      this.show_table = false;
    },
    close_generic_table() {
      if (this.show_generic_table) {
        //this.show_generic_table=false;
        document.getElementById("right_form").style.display = "flex";
      }

      this.show_generic_table = false;
    },

    close_calendar() {
      if (this.show_calendar) {
        document.getElementById("form_btn_container").style.display = "flex";
        //document.getElementById('right_form').style.display = 'flex';
      }
      this.show_calendar = false;
    },

    triggerAction(action) {
      // console.log("action to perform:", action)
      if (action.action === "create_viatura") {
        this.create_viatura_ = true;
        this.form_title = "Criar Viatura";
        this.setViaturaForm(null);

        this.close_generic_table();
        this.close_calendar();
        this.clear_manutencao();
        this.show_form = true;
      }
      if (action.action === "show_table") {
        this.show_table = true;
      }
      if (action.action === "criar_filtro") {
        this.show_form_filter = true;
      }
    },
    async create(data, url) {
      try {
        const res = await axios.post(url, data);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async select(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async select_all(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async update(url, data) {
      try {
        const res = await axios.put(url, data);
        console.log("Data successfully updated:", res.data);
        return res.data.data;
      } catch (error) {
        console.error("Error posting data:", error);
      }
    },
    async remove(url) {
      // console.log("Data:", data.id)
      try {
        await axios.delete(url);
        return true;
      } catch (error) {
        console.error("Error deleting data:", error);
      }
    },

    setViaturaForm(data) {
      const isEmptyObject = (obj) =>
        Object.keys(obj).length === 0 && obj.constructor === Object;
      this.viatura_formData = {
        id: data && data.id ? data.id : 0,
        matricula: data && data.matricula ? data.matricula : "",
        marca: data && data.marca ? data.marca : "",
        modelo: data && data.modelo ? data.modelo : "",
        tipo_viatura:
          data && data.tipo && !isEmptyObject(data?.tipo)
            ? { id: data.tipo.id, nome: data.tipo.nome }
            : "",
        tipos: this.viatura_tipos,
        observacao: data && data.observacao ? data.observacao : "",
        danos: data && data?.danos ? data.danos : "",
        ano: data && data?.ano ? data.ano : "",
        mes: data && data?.mes ? data.mes : "",
        cor: data && data?.cor ? data.cor : "",
        volumetria: data && data.volumetria ? data.volumetria : "",
        km: data && data.km ? data.km : "",
        kmManutencao: data && data.kmManutencao ? data.kmManutencao : "",
        status: data && data.status ? data.status : "",
        foto: data && data.foto ? data.foto : require("@/assets/car_logo.svg"),
        oficina: data && data.oficina ? data.oficina : "",
        manutencao: data && data.manutencao ? data.manutencao : "",
      };

      this.viatura_setData = {
        tipo_viatura:
          data && data.tipo && !isEmptyObject(data?.tipo)
            ? data.tipo
            : { id: 0, nome: "Não Atribuido" },
        utilizador:
          data && data.utilizador && !isEmptyObject(data?.utilizador)
            ? data.utilizador
            : { id: 0, user: "Não Atribuido" },
        armazem:
          data && data.armazem && !isEmptyObject(data?.armazem)
            ? data.armazem
            : { id: 0, nome: "Não Atribuido" },
        gps:
          data && data.gps && !isEmptyObject(data?.gps)
            ? data.gps
            : { id: 0, nome: "Não Atribuido" },
      };
    },

    setData(data) {
      let prepared_data = {
        matricula: data.matricula || "",
        marca: data.marca || "",
        modelo: data.modelo || "",
        tpViatura_id: data?.tipo_viatura?.id || 0,
        observacao: data.observacao || "",
        danos: data.danos || "",
        armazem_id: data?.armazem?.id || 0,
        utilizador_id: data?.utilizador?.id || 0,
        gps_id: data?.gps?.id || 0,
        ano: data.ano || "",
        mes: data.mes || "",
        cor: data.cor || "",
        volumetria: data.volumetria || "",
        km: data.km || "",
        kmManutencao: data.kmManutencao || "",
        oficina: data.oficina || "",
        manutencao: data.manutencao || "",
      };
      return prepared_data;
    },
    show_form_table(data) {
      if (data === "manutencao") {
        this.show_calendar = true; 
        document.getElementById("form_btn_container").style.display = "flex";
    }
      this.show_groupby=false;
      const tableMappings = {
        armazem: { title: "Armazéns", url: `armazem` },
        tipo: { title: "Tipos", url: `tpviatura` },
        utilizador: { title: "Utilizadores", url: `utilizador` },
        gps: { title: "GPS", url: `gps` },

        stock: {
          data: [{ Tarefa: "Ainda não implementada" }],
          title: "Stocks",
          url:`viatura/${this.viatura.id}/stock`,
          groupby: { show: true, field: "equipamento" },
        },
        mapas: {
          data: [{ Tarefa: "Ainda não implementada" }],
          title: "Mapas",
         
        },
        portagens: {
          data: [{ Tarefa: "Ainda não implementada" }],
          title: "Portagens",
        },
        consumos: {
          data: [{ Tarefa: "Ainda não implementada" }],
          title: "Consumos",
        },
        escalas: {
          data: [{ Tarefa: "Ainda não implementada" }],
          title: "Tarefas",
        },
        // manutencao: { title: "Manutenção", url: `manutencao` },
      };

      const mapping = tableMappings[data];
      if (mapping) {
        this.current_table = data;
        this.generic_table_title = mapping.title;
        this.urlString = mapping.url
        this.show_groupby = mapping?.groupby?.show||false;
        this.generic_table_data = mapping.data;

        this.show_generic_table = true;
        this.refresh = true
        document.getElementById("right_form").style.display = "none";

        this.popUp = mapping.popUp;
      }
    }
    ,

    save_calendar(data) {
      this.viatura_manutencao = data;
      console.log("parent manutencao:", this.viatura_manutencao);
      this.close_calendar();
    },


async add_manutencao(data) {
      console.log("parent status:", data);
      let update_data = {
        manutencao: data.manutencao == "ativo" ? "desativo" : "ativo",
      };
      const res = await this.update(
        `${this.baseURl}/api/v1/viatura/editar/${data.id}/`,
        update_data
      );
      if (res) {
        console.log("viatura updated", res);
        const message =
          data.manutencao == "ativo" ? "retirado da" : "enviado para a";
        this.viatura_formData.manutencao = update_data.manutencao;
        toast.success(`Viatura  ${message} manutencao com sucesso`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        await this.get_viaturas();
      } else {
        const message = data.manutencao == "ativo" ? "enviar" : "enviar";
        toast.error(`Erro ao ${message} Viatura para manutencao`, {
          autoClose: 1000,
        });
      }
    },
async add_oficina(data) {
      console.log("parent status:", data);
      let update_data = {
        oficina: data.oficina == "ativo" ? "desativo" : "ativo",
      };
      const res = await this.update(
        `${this.baseURl}/api/v1/viatura/editar/${data.id}/`,
        update_data
      );
      if (res) {
        console.log("viatura updated", res);
        const message =
          data.oficina == "ativo" ? "retirado da" : "enviado para a";
        this.viatura_formData.oficina = update_data.oficina;
        toast.success(`Viatura  ${message} oficina com sucesso`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        await this.get_viaturas();
      } else {
        const message = data.oficina == "ativo" ? "enviar" : "enviar";
        toast.error(`Erro ao ${message} Viatura para oficina`, {
          autoClose: 1000,
        });
      }
    },


    async manage_manutencao(user) {
      console.log("manutencao to create/update:", this.viatura_manutencao);
      this.viatura_manutencao.map(async (manutencao) => {
        const manutencao_data = {
          inicio: manutencao.start.toISOString().split("T")[0],
          fim: manutencao.end.toISOString().split("T")[0],
          status: manutencao.status,
          viatura_id: user.id,
          descricao: manutencao?.descricao ? manutencao.descricao : "",
          aceite: manutencao?.aceite ? manutencao.aceite : "ok",
        };
        console.log("manutencao:", manutencao_data);
        if (manutencao.id == 0) {
          await this.create(
            manutencao_data,
            `${this.baseURl}/api/v1/manutencao/registrar/`
          );
        } else {
          if (manutencao.status == "deleted")
            await this.remove(
              `${this.baseURl}/api/v1/manutencao/eliminar/${manutencao.id}/`
            );
          else
            await this.update(
              `${this.baseURl}/api/v1/manutencao/editar/${manutencao.id}/`,
              manutencao_data
            );
        }
      });
    },

    clear_manutencao() {
      this.viatura_manutencao = [];
    },


    
    async disable_viatura(data) {
      console.log("parent status:", data);
      let update_data = {
        status: data.status == "ativo" ? "desativado" : "ativo",
      };
      const res = await this.update(
        `${this.baseURl}/api/v1/viatura/editar/${data.id}/`,
        update_data
      );
      if (res) {
        console.log("viatura updated", res);
        const message = data.status == "ativo" ? "desativado" : "ativado";
        this.viatura_formData.status = update_data.status;
        toast.success(`Viatura ${message} com sucesso`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        await this.get_viaturas();
      } else {
        const message = data.status == "ativo" ? "desativar" : "ativar";
        toast.error(`Erro ao ${message} Viatura`, {
          autoClose: 1000,
        });
      }
    },
    
    async upload_img(formData) {
      if (formData.newFoto) {
        try {
          const response = await axios.post(
            `${this.baseURl}/api/v1/viatura/editar/foto/${formData.id}/`,
            formData.newFoto,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          const filePath = response.data.filePath;
        } catch (error) {
          console.error("Error uploading file:", error);
        }
      }
    },
    async get_imagem(id) {
      if (id == 0) return;
      try {
        const response = await axios.get(
          `${this.baseURl}/api/v1/viatura/foto/${id}/`,
          { responseType: "blob" }
        );
        // Create a local URL of the image
        if(response.status != 200) return;
        this.viatura_formData.foto = URL.createObjectURL(
          new Blob([response.data])
        );
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {
    async selectedFiltro(newFiltro) {
      if (newFiltro) {
        this.filtroData = { ...newFiltro };
        delete this.filtroData.id;
        delete this.filtroData.status;
        this.show_table = true;
        this.table_title =
          this.filtroData.nome.charAt(0).toUpperCase() +
          this.filtroData.nome.slice(1).toLowerCase();
        const response = await axios.post(
          `${this.baseURl}/api/v1/filtro/testar/`,
          this.filtroData
        );
        this.viaturas = response.data.data;
      } else {
        this.get_viaturas();
        this.table_title = "Viaturas";
        this.show_table = true;
      }
    },
  },
};
</script>

<style>
.scroll-style {
  overflow-y: auto;
  scrollbar-color: gray transparent;
  scrollbar-width: thin;
}

.popup {
  position: fixed;
  display: none;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border: 1px solid black;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}

.popup-content {
  text-align: center;
}

.popup button {
  margin: 0 10px;
  padding: 5px 10px;
  cursor: pointer;
}

.btn {
  font-size: 12px;
  width: fit-content;
  padding: 0.5rem 0.8rem;
  color: white;
  display: flex;
  align-items: center;
  border-radius: 10px;
  background-color: #626288;
}

.btn:hover {
  background-color: #c67700;
}

.scrollbar-tema {
  scrollbar-width: thin;
  scrollbar-color: var(--scroll) transparent;
}
</style>
